module.exports = __webpack_public_path__ + "static/media/sea-farm.f476a7c6.jpg";